const config = {
    name: 'Accessible view',
    link: 'http://assistive.jcpenney.com/h5/access/index',
};

export default config;
